import React from 'react';
import "./index.css";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import PropTypes from "prop-types";

AttachmentModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    selectedItems: PropTypes.array.isRequired,
};

function AttachmentModal(props) {
    return (
        <Modal isOpen={props.isOpen} style={{maxWidth: 1024}}>
            <ModalHeader className="border-0">

            </ModalHeader>
            <ModalBody className="justify-content-center attachment-modal-body">
                {props.children}
            </ModalBody>
            <ModalFooter className="border-0 justify-content-center">
                <div className="divider-copy"/>
                <div className="display-flex-end padding-16">
                    <div>
                        <Button color="outline-secondary"
                                style={{marginLeft: 16, marginRight: 16, width: 100}}
                                onClick={props.previous}>
                            {
                                props.attachmentState === "selection"
                                    ?
                                    "CANCEL"
                                    :
                                    "BACK"
                            }
                        </Button>
                    </div>
                    <div>
                        <Button color="primary"
                                disabled={props.selectedItems.length === 0}
                                style={{marginLeft: 16, marginRight: 32, width: 100}}
                                onClick={props.next}>
                            {
                                props.attachmentState === "selection"
                                    ?
                                    "NEXT"
                                    :
                                    (
                                        props.attachmentState === "price"
                                            ?
                                            "PREVIEW"
                                            :
                                            "SEND"
                                    )
                            }
                        </Button>
                    </div>
                </div>
            </ModalFooter>
        </Modal>
    );
}


// Specifies the default values for props:
AttachmentModal.defaultProps = {};

export default AttachmentModal;